import { computed, Injectable, signal } from '@angular/core';
import { Item } from '../types/item';

@Injectable()
export class ItemService {
  readonly #items = signal<Item[]>([]);

  readonly items = computed(() => this.#items());

  addItem(item: Item) {
    const items = [...this.#items()];
    items.push(item);
    this.#items.set(items);
  }

  removeItem(item: Item) {
    const items = [...this.#items()];
    this.#items.set(items.filter((i) => i.id !== item.id));
  }

  clear() {
    this.#items.set([]);
  }
}
